// Centered spinner used by PrivateRoute while auth state is resolving,
// and by Suspense fallbacks across the app.
export default function Loading({ label = 'Cargando...' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-text-muted"
    >
      <span
        aria-hidden="true"
        className="h-10 w-10 animate-spin rounded-full border-2 border-border border-t-accent"
      />
      <span className="text-sm font-body">{label}</span>
    </div>
  );
}
